enum SubSections {
  NewPrice = 'new-price',
  GreatDeal = 'great-deal',
  EvTaxCredit = 'ev-tax-credit'
}

export default SubSections;
